import React from "react";
import styled from "styled-components";

type Props = {
  summary?: string;
  type: "warning" | "error";
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
`;

export default function ErrorMessage({ summary, type }: Props) {
  return (
    <div
      data-testid="inline-error-message"
      className={
        type === "warning"
          ? "p-message p-message-warn"
          : "p-message p-message-error"
      }
    >
      <Wrapper className="p-message-wrapper">
        <div className="mr-4 flex align-items-center">
          <i
            className={
              type === "warning"
                ? "p-message-icon pi pi-info-circle"
                : "p-message-icon pi pi-times-circle"
            }
            style={{ fontSize: "1.5rem" }}
          />
        </div>
        <div>
          <span className="block font-bold">{summary}</span>
        </div>
      </Wrapper>
    </div>
  );
}
